/* eslint-disable no-unused-vars */
import { ControllerModel } from "../_model/ControllerModel";
import { Arrow } from "./modelArrow.js";

class ControllerArrow extends ControllerModel {
  constructor() {
    super("ControllerArrow");
    
    this.setNewNode = (callback) => {
      let arrow = new Arrow();
      arrow.decorate(callback);

      this.addNode(arrow);
    }

    this.loadNode = (node, callback) => {
      let arrow = new Arrow();
      arrow.copyFrom(node);
      arrow.decorate(callback);
      this.addNode(arrow)
    }

    this.getProperties = async (node) => {
      let n = new Arrow();
      await n.copyFrom(node);
      return n.data
    }

    this.getNode = (node) => {
        let n = new Arrow();
        n.copyFrom(node);
        return n
    }
  }
}

export { ControllerArrow };
